module.exports = __webpack_public_path__ + "sgby/img/active-point.c851af9.png";